import { AuthActions } from "../LoginRedux/Action";
import { pickerOrderActions } from "./Action";

const initialState = {
  pickerOrderDetailsSuccess: null,
  pickerOrderError: null,
  missingMeds: null,
  missingMedsError: null,
  saveMedsSuccess: null,
  saveMedsFailure: null,
  confirmMedsError: null,
};

export const pickerorderReducer = (state = initialState, action) => {
  switch (action.type) {
    case pickerOrderActions.CLEAR_PICKER_ORDER_DATA:
      return {
        ...state,
        pickerOrderDetailsSuccess: null,
        pickerOrderDetailsFailure: null,
      };
    case pickerOrderActions.FETCH_PICKER_ORDER_DATA_SUCCESS:
      return {
        ...state,
        pickerOrderDetailsSuccess: action.payload,
        pickerOrderError: null,
      };

    case pickerOrderActions.FETCH_PICKER_ORDER_DATA_FAILURE:
      return {
        ...state,
        pickerOrderDetailsSuccess: null,
        pickerOrderError: action.payload,
      };
    case pickerOrderActions.SAVE_MISSING_MEDS_SUCCESS:
      return {
        ...state,
        saveMedsSuccess: action.payload,
        saveMedsFailure: null,
      };

    case pickerOrderActions.SAVE_MISSING_MEDS_FAILURE:
      return {
        ...state,
        saveMedsSuccess: null,
        saveMedsFailure: action.payload,
      };

    case pickerOrderActions.FETCH_MED_MISSING_DETAILS_SUCCESS:
      return {
        ...state,
        missingMeds: action.payload,
        missingMedsError: null,
      };

    case pickerOrderActions.FETCH_MED_MISSING_DETAILS_FAILURE:
      return {
        ...state,
        missingMeds: null,
        missingMedsError: action.payload,
      };

    case pickerOrderActions.CONFIRM_MISSING_MED_DETAILS_SUCCESS:
      return {
        ...state,
        confirmMedsError: null,
      };

    case pickerOrderActions.CONFIRM_MISSING_MED_DETAILS_FAILURE:
      return {
        ...state,
        confirmMedsError: action.payload,
      };

    case AuthActions.Logout_User:
      return {
        pickerOrderDetailsSuccess: null,
        pickerOrderError: null,
        missingMeds: null,
        missingMedsError: null,
      };

    default:
      return state;
  }
};
